import { datadogRum } from '@datadog/browser-rum'
import { type SalesEventCartItem } from '../types/base/ga4-events'

export const toAletheiaItem = (item: SalesEventCartItem, eventName: string) => {
  const { parent_product_id, item_flavor, ...rest } = item
  if (!parent_product_id) {
    datadogRum.addError(
      new Error(`Aletheia ${eventName} product_id fallback to item_id`),
      { item_id: item.item_id, item_name: item.item_name },
    )
  }
  return {
    ...rest,
    product_id: parent_product_id ?? item.item_id,
    item_variant: item_flavor ?? rest.item_variant,
  }
}
